export default __webpack_public_path__ + "static/media/move-arte-1.fcb688d2.webp";